module.exports = __webpack_public_path__ + "static/img/frame.d8a762bf.png";